import classnames from 'classnames';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';
import { Button } from 'ui-components/components/button';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';
import { Modal } from 'ui-components/components/modal';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalFrameworkMethodsPropType } from 'ui-components/prop-types/modal-framework-methods';

import style from './styles.module.less';
import Global from '../../../store/global-selectors';

const messages = defineMessages({
  header: {
    description: 'Bulk update feedback modal header text',
    defaultMessage: 'Bulk Update complete',
    id: '/3Ih8b',
  },
  closeButton: {
    description: 'close button label text',
    defaultMessage: 'Close',
    id: 'LkATlh',
  },
  warningBannerText: {
    description: 'message providing successful & skipped order count',
    defaultMessage:
      'Update applied to {successful, plural, one {# order} other {# orders}} and {skipped, plural, one {# order} other {# orders}} skipped.',
    id: 'qOC0Rb',
  },
  skippedReasonText: {
    description: 'Title for list of reasons why some orders were skipped from selected bulk action',
    defaultMessage: 'Orders associated with the following are not eligible for bulk updates:',
    id: 'AOTYqH',
  },
});

export const BulkUpdateFeedbackModal = (props) => {
  const { processedCount, skippedCount, skippedMarketplaces } = props.bulkActionResults;
  const { closeModal } = props.modalFrameworkMethods;
  const marketplaces = useSelector(Global.selectReferenceDatagetMarketplaces);
  const skippedReasons = marketplaces.filter(({ marketplaceId }) => skippedMarketplaces.includes(marketplaceId));
  return (
    <Modal className={classnames(style['bulk-update-feedback-modal'])}>
      <ModalHeader closeModal={closeModal}>
        <FormattedMessage {...messages.header} />
      </ModalHeader>
      <ModalBody>
        <div>
          <div className={style['main-content']}>
            <BannerMessageV2
              className={style['error-message']}
              content={<FormattedMessage {...messages.warningBannerText} values={{ successful: processedCount, skipped: skippedCount }} />}
              status={BannerStatus.Warning}
            />
            <div className={style['reasons-list']}>
              <FormattedMessage {...messages.skippedReasonText} />
              <ul>
                {skippedReasons.map((reason) => (
                  <li key={reason.id}>{reason?.name}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </ModalBody>
      <ModalFooter className={style['modal-footer']}>
        <Button onClick={closeModal} theme={THEME_CONSTANTS.tertiary}>
          <FormattedMessage {...messages.closeButton} />
        </Button>
      </ModalFooter>
    </Modal>
  );
};

BulkUpdateFeedbackModal.propTypes = {
  bulkActionResults: PropTypes.object.isRequired,
  modalFrameworkMethods: ModalFrameworkMethodsPropType.isRequired,
};
